export default "__VITE_ASSET__7218c513__"